module.exports = __webpack_public_path__ + "img/pirassununga.44fd5681.png";